import Multiselect from 'vue-multiselect';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import ITariff from '@/interfaces/ITariff';
import capitalizeFirstLetter from '@/libs/capitalizeFirstLetter';
import dateToStandart from '@/libs/date/dateToStandart';
import BillingStrategy from '@/types/billingStrategy';
import { namespace } from 'vuex-class';
import IPaymentProviderModel from '@/interfaces/IPaymentProviderModel';

const paymentProviderModelModule = namespace('paymentProviderModel');

@Component({
    name: 'TariffForm',
    components: {
        Multiselect,
        Loader,
        CardHeader
    }
})
export default class TariffForm extends Vue {
    @paymentProviderModelModule.Action private readonly fetchPaymentProviderModels!: (params: {query: string}) => Promise<IPaymentProviderModel[]>;
    @Prop(Object) private tariffData!: ITariff;

    private formFields: ITariff | null = null;
    private isEdit: boolean = false;

    private paymentProviderModels: Array<{value: number; text: string}> = [];

    public get loading():boolean {
        return !this.tariffData;
    }

    public isCannotEdit(field: string):boolean {
        return field === 'createdAt' || field === 'updatedAt' || field === 'id';
    }

    public disabledField(field: string):boolean {
        return !this.isCreateForm && !this.isCannotEdit(field) ? !this.isEdit && !this.isCannotEdit(field) : this.isCannotEdit(field)
    }

    public transformLabel(nameField: string): string {
        return capitalizeFirstLetter(nameField);
    }

    private get billingStrategies() {
        return [BillingStrategy.lifetime, BillingStrategy.subscription];
    }

    private get btnIcon() {
        return !this.isEdit ? 'icon-pencil' : 'icon-lock';
    }

    private get editBtnText() {
        return !this.isEdit ? 'Edit' : 'Lock';
    }

    private get isCreateForm(): boolean {
        return !!this.$route.name && ['subscription_tariff_create', 'tariff_create'].includes(this.$route.name);
    }

    private get btnText() {
        return this.isCreateForm ? 'Create' : 'Update';
    }

    @Watch('isSubscriptionTariff', { immediate: true })
    onIsSubscriptionTariffChanged(isSubscriptionTariff: boolean) {
        const fields = {...this.tariffData};

        if (isSubscriptionTariff) {
            // @ts-ignore
            delete fields.productId;
        }

        this.formFields = fields;
    }

    private get isSubscriptionTariff(): boolean {
        return this.$route.name === 'subscription_tariff_detail';
    }

    private editForm() {
        return this.isEdit = !this.isEdit;
    }

    private sendForm() {
        if (this.formFields) {
            const data = {...this.formFields};
    
            delete data.createdAt;
            delete data.updatedAt;
    
        
            this.$emit(this.isCreateForm ? 'tariffCreate' : 'tariffUpdate', data);
        }
    }

    private cancelForm() {
        this.$router.go(-1);
    }

    private async mounted() {
        const paymentProviderModels = await this.fetchPaymentProviderModels({query: `?page=1&limit=300&pagination=true`});

        this.paymentProviderModels = paymentProviderModels.map(({id: value, name: text}) => ({value, text}));
        this.paymentProviderModels.unshift({
            text: '',
            value: 0
        })
    }
}
